import React from 'react';
import { Button, ButtonGroup, Text } from '@zillow/constellation';
import styled from 'styled-components';

const OrganizePagesContainer = styled.div`
  width: 100%;
  background: ${props => props.theme.constellation.colors.white};
  display: flex;
  padding: 0.75rem 1.5rem;
  border: solid 1px ${props => props.theme.constellation.colors.gray300};

  & > * {
    margin: auto;
  }
`;

const HeaderDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const CollectionItemName = styled(Text)`
  margin-bottom: 0.25rem;
`;

const HeaderSpacer = styled.div`
  flex-grow: 2;
  margin-left: 0.5rem;
`;

type Props = {
  documentName: string;
  onSave: () => void;
  onCancel: () => void;
};
const OrganizePagesHeader = function ({
  documentName,
  onSave,
  onCancel,
}: Props) {
  return (
    <OrganizePagesContainer>
      <HeaderDetails>
        <CollectionItemName fontType="h6" fontColor="gray600" as="h5">
          Split Document: {documentName}
        </CollectionItemName>
      </HeaderDetails>
      <HeaderSpacer />
      <ButtonGroup aria-label="Organize Pages actions">
        <Button marginRight="1.5" onClick={onCancel}>
          Cancel
        </Button>
        <Button marginRight="1.5" buttonType="primary" onClick={onSave}>
          Save
        </Button>
      </ButtonGroup>
    </OrganizePagesContainer>
  );
};

export default OrganizePagesHeader;
